<div class="modal-header">
  <h4 class="modal-title pull-left">{{'newTexturePopup.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner pt-2">
    <form novalidate [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'newTexturePopup.label.name' | translate}}</label>
        <div class="col-md-2">
          <input type="text" class="form-control border" name="textureNamePrefix" readonly value="{{textureNamePrefix}}">
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control border" name="textureName" formControlName="textureName"
            inputRestricter="^[0-9_]*$" [class.is-invalid]="getInputError(form.get('textureName'))">
          <div class="invalid-feedback">{{getInputError(form.get('textureName'))}}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-md-8 offset-md-4">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="autoGenerateTextureName" formControlName="autoGenerateTextureName"
              (change)="autoGenerateTextureNameHandler()">
            <label class="form-check-label" for="autoGenerateTextureName">{{'newTexturePopup.autoName' | translate}}</label>
          </div>
        </div>
      </div>
    </form>
    <div>
      <div class="mb-3 row" *ngIf="imageUrl">
        <label class="col-md-4 col-form-label font-weight-bold">
          {{'newTexturePopup.label.image' | translate }}:
        </label>
        <img class="pl-3"
            [attr.width.px]="imageContainerWidth"
            [attr.height.px]="imageContainerHeight"
            [src]="imageUrl"/>
      </div>
      <div class="mb-3 row">
        <div  class="col-md-4">
          <label *ngIf="!imageUrl" class="form-label font-weight-bold">
            {{'newTexturePopup.label.image' | translate }}:
          </label>
        </div>
        <div class="col-md">
          <input class="form-control is-valid inputfile"
                 id="new-texture-file"
                 name="new-texture-file"
                 type="file"
                 accept="/*.jpeg, /*.jpg, /*.png"
                 (change)="imageUpload($event)">
          <label class="btn btn-primary col-md-12" for="new-texture-file">
            <i class="mdi mdi-upload"></i>
            {{'newTexturePopup.label.select_image' | translate}}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button class="btn btn-primary" (click)="save()" [disabled]="!isSubmitAvailable()">
    {{'newTexturePopup.addTexture' | translate}}
  </button>
</div>
